export default {"src":"/_next/static/media/SCHW.d61ef6a7.svg","height":18,"width":18};